import { Component } from "react";
import PropTypes from "prop-types";
import ListingContent from "app/pages/Listing/ListingContent/ListingContent";
import { connect } from "react-redux";
import { getListingItems, isAnyListingFilterActive } from "app/pages/Listing/productsSelector";

class ListingContentContainer extends Component {
	render() {
		return <ListingContent {...this.props} />;
	}
}

ListingContentContainer.propTypes = {
	spotlightUri: PropTypes.string,
	isListViewDisplay: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
	return {
		isAnyListingFilterActive: isAnyListingFilterActive(state),
		orderedListingItems: getListingItems(props.spotlightUri)(state),
		resolution: state.resolution,
		showSmartDPOnRootUrl: state.partner.showSmartDPOnRootUrl,
	};
};

export default connect(mapStateToProps)(ListingContentContainer);
